import React from 'react';
import TemplatePage, {TemplatePageProps} from "../template_page/template_page";
import {Page} from "../../model/page";
import C74Sitemap from "../../luiss_components/c74_sitemap/c74_sitemap";

class SitemapPage extends TemplatePage {
    constructor(props: TemplatePageProps) {
        super(props);

        this.dataUrl = undefined;
    }

    componentDidMount(): void {
        super.componentDidMount();

        let title = "";
        if (this.props.path && (this.props.path === "/sitemap-page" || this.props.path === "/sitemap-page/")) {
            title = "Sitemap";
        }

        let data = {
            title: title,
            two_columns: false,
            desktop_navbar_color: "dark",
            mobile_navbar_color: "dark",
            components: [],
            path: undefined
        };

        this.setState({
            data: data
        });

        this.onDataLoaded(data);
    }

    beforeRightComponentsList(page: Page): React.ReactElement {
        return <C74Sitemap layoutColumns={1} language={this.props.language} />;
    }
}

export default SitemapPage;